import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import TopSearch from './TopSearch'
import DialogPopup from 'components/molecules/DialogPopup';
import PopupSyllabus from '../workspace/PopupSyllabus';
import PopupResources from '../workspace/PopupResources';
import PopupBookmarks from '../workspace/PopupBookmarks';
import tab from 'assets/images/tab.png';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { Avatar, Link } from '@mui/material';
import { PRIMARY_TRANSPARENT_GREEN } from 'utils/customizedTheme';
import SectionPrintables from './SectionPrintables';
import SectionGames from './SectionGames';
import SectionMyTarget from './SectionMyTarget';
import SectionBigMyWork from './SectionBigMyWork';
import SectionSubjectPath from './SectionSubjectPath';
import SectionSubjectAssignments from './SectionSubjectAssignments';
import SectionMySchedule from './SectionMySchedule';
import AvatarInParts from './AvatarInParts';
import PopupGames from '../workspace/PopupGames';

const WorkspaceBig: FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [popup, setPopup] = useState(null)
  const [popupTitle, setPopupTitle] = useState(null)

  const [topSearch, setTopSearch] = useState(null)

  const user = useSelector((state: RootState) => state['user'].user)

  return (
      <>
            <div className="container">

                <div className="workspace-top-tabs">

                    <div className="workspace-top-tab" style={{ backgroundImage: `url(${tab})`}}
                        onClick={() => {
                            setPopupTitle(t('common.syllabus'))
                            setPopup('syllabus')
                        }}>
                        <div className="workspace-top-tab-title">{t('common.syllabus')}</div>
                    </div>

                    <div className="workspace-top-tab" style={{ backgroundImage: `url(${tab})`}}
                        onClick={() => {
                            navigate(`/my-curriculum-map`)
                        }}>
                        <div className="workspace-top-tab-title">{t('goalbank.lessons')}</div>
                    </div>

                    <div className="workspace-top-tab" style={{ backgroundImage: `url(${tab})`}}
                        onClick={() => {
                            setPopupTitle(t('goalbank.resources'))
                            setPopup('resources')
                        }}>
                        <div className="workspace-top-tab-title">{t('goalbank.resources')}</div>
                    </div>

                    <div className="workspace-top-tab" style={{ backgroundImage: `url(${tab})`}}
                        onClick={() => {
                            setPopupTitle(t('dashboard.bookmarks'))
                            setPopup('bookmarks')
                        }}>
                        <div className="workspace-top-tab-title">{t('dashboard.bookmarks')}</div>
                    </div>
                    
                </div>

                <div style={{ height: '40px' }} />

                <TopSearch handleSearch={(qry) => {
                    setPopupTitle(t('goalbank.resources'))
                    setTopSearch(qry)
                    setPopup('resources')
                }} />


                
{user && <div className='workspace-avatar'>


{user?.student_profile?.avatar && user.student_profile?.avatar_parts && 
<AvatarInParts parts={user.student_profile.avatar_parts}/>
}  

{!user?.student_profile?.avatar &&
<Avatar
      className='avatar'
      sx={{
        bgcolor: PRIMARY_TRANSPARENT_GREEN,
        width: 100,
        height: 100,
        marginLeft: '20px',
        marginRight: '20px',   
        display: 'inline-block',
        position: 'relative',
        lineHeight: '70px',
        textAlign: 'center'
      }}
      variant='circular'
      src={user.student_profile?.avatar}
    /> }

<div className='workspace-avatar-title'>
    {t('dashboard.workspace-hello',{name: user.first_name})}
</div>
</div>}


                <h1 className='workspace-title'>{t('dashboard.from-my-teacher')}</h1>
                <SectionSubjectPath />  
                <SectionSubjectAssignments />           

                <h1 className='workspace-title'>{t('dashboard.my-work')}</h1>
                <SectionBigMyWork />

                <h1 className='workspace-title'>{t('dashboard.where-i-am-now')}</h1>
                <SectionMyTarget />             

                <SectionMySchedule />           

                <h1 className='workspace-title'>{t('dashboard.my-games')}</h1>
                <SectionGames />    
                <div style={{marginTop: '20px'}}  >
                    <Link className='setup-link' onClick={() => {
                        setPopupTitle(t('dashboard.game-zone'))
                        setPopup('games')
                    }}>{t('common.see-all')}</Link>
                </div>     

                <h1 className='workspace-title'>{t('dashboard.my-printables')}</h1>
                <SectionPrintables />
                <div style={{marginTop: '20px'}} >
                    <Link className='setup-link' style={{marginTop: '20px'}}  onClick={() => {
                        setPopupTitle(t('goalbank.resources'))
                        setPopup('resources')
                        }}>{t('common.see-all')}</Link>
                </div>

            </div>


        <DialogPopup
            title={popupTitle}
            open={!!popup}
            onClose={() => setPopup(null)}
            popupWidth={'1400px'}
            fullScreen={popup === 'games'}
        >
           <>
            {popup === 'syllabus' && <PopupSyllabus />}
            {popup === 'resources' && <PopupResources qry={topSearch} />}
            {popup === 'bookmarks' && <PopupBookmarks />}
            {popup === 'games' && <PopupGames />}
           </>
        </DialogPopup>



        




      
      </>
  )
}

export default WorkspaceBig
